export enum MenuTypesEnum {
  IS_WEB_ORDERING = 'isWebOrdering',
  IS_KIOSK = 'isKiosk',
  IS_PARKED = 'isParked',
  IS_DELIVERY_PARTNER = 'isDeliveryPartner',
  IS_POS = 'isPOS',
  IS_ORDER_AT_TABLE = 'isOrderAtTable',
  IS_MOBILE = 'isMobile',
  IS_ULTRA_ORDER = 'isUltraOrder',
}